import type { AllowedUtmQuery } from '~/utils/utm'

export type GtmEventName
  = | 'banner_clicked'
    | 'simulation_started'
    | 'simulation_finished'
    | 'simulation_result_viewed'
    | 'financing_details_viewed'
    | 'financing_details_exited'
    | 'proposal_started'

export interface GtmUserProperties extends AllowedUtmQuery {
  userId?: string
  partnerId?: string
  projectId?: string
  financingId?: string
  profile?: string
  userType?: string
  isAdmin?: boolean
  project_value?: number
  system_power?: number
  system_type?: string | null
}

export type GtmUserPropertyKey = keyof GtmUserProperties

export const GTM_USER_PROPERTY_KEYS = [
  'userId',
  'partnerId',
  'projectId',
  'financingId',
  'profile',
  'userType',
  'isAdmin',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'project_value',
  'system_power',
  'system_type',
] as const satisfies readonly GtmUserPropertyKey[]

export interface SimulationResultViewedEventPayload {
  project_value: number
  system_power: number
  system_type?: string | null
}

export interface SimulationFinishedEventPayload {
  result: string
  success: boolean
  projectId?: string
  reason?: string
}

export interface FinancingDetailsExitedEventPayload {
  projectId: string
  personType: string
  enable_dynamic_due_day: boolean
}

export interface ProposalStartedEventPayload {
  projectId: string
  personType: string
}
